import { FAQ } from '@/components/landing/marketing/FAQ';
import { SaaSShowcase } from '@/components/landing/marketing/SaaSShowcase';
import { SEO } from '@/components/landing/shared/SEO';
import { motion } from 'framer-motion';

const PricingPage = () => {
    return (
        <div className="relative min-h-screen pt-32 pb-20 bg-background overflow-hidden selection:bg-primary/20 selection:text-foreground">
            <SEO
                title="AI Chatbot Pricing - Start Free | Affordable Chatbot Plans"
                description="Transparent AI chatbot pricing. Start with a free plan — no credit card — and put a chatbot online from $9.99/month. Free AI chatbot trial for small businesses, no hidden fees."
                url="https://chytbot.com/pricing"
                keywords={[
                    "chatbot pricing",
                    "AI chatbot cost",
                    "affordable chatbot USA",
                    "chatbot plans",
                    "free chatbot trial",
                    "free AI chatbot",
                    "AI chatbot free",
                    "free chatbot",
                    "chatbot free",
                    "free AI chat",
                    "AI chat free",
                    "chatbot free online",
                    "chat bot online free",
                    "small business chatbot pricing",
                    "customer support automation cost",
                    "ChytBot pricing",
                    "chatbot subscription",
                    "SaaS chatbot pricing"
                ]}
                structuredData={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": "ChytBot AI Chatbot Platform",
                        "description": "AI-powered chatbot builder for US businesses",
                        "brand": {
                            "@type": "Brand",
                            "name": "ChytBot"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "name": "Free Plan",
                                "price": "0",
                                "priceCurrency": "USD",
                                "priceValidUntil": "2027-12-31",
                                "availability": "https://schema.org/InStock",
                                "url": "https://chytbot.com/pricing"
                            },
                            {
                                "@type": "Offer",
                                "name": "Starter Plan",
                                "price": "9.99",
                                "priceCurrency": "USD",
                                "priceValidUntil": "2027-12-31",
                                "availability": "https://schema.org/InStock",
                                "url": "https://chytbot.com/pricing"
                            },
                            {
                                "@type": "Offer",
                                "name": "Business Plan",
                                "price": "19.99",
                                "priceCurrency": "USD",
                                "priceValidUntil": "2027-12-31",
                                "availability": "https://schema.org/InStock",
                                "url": "https://chytbot.com/pricing"
                            }
                        ],
                        "aggregateRating": {
                            "@type": "AggregateRating",
                            "ratingValue": "4.8",
                            "reviewCount": "150"
                        }
                    }
                ]}
            />

            {/* Premium Background Ornaments */}
            <div className="absolute top-0 left-0 w-full h-[800px] bg-gradient-to-b from-primary/5 via-background to-transparent pointer-events-none -z-10" />
            <div className="absolute top-[-5%] right-[-10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] pointer-events-none -z-10" />

            <div className="container relative px-4 mx-auto">
                {/* Minimal Header */}
                <motion.div
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="max-w-3xl mx-auto text-center mb-16"
                >
                    <h1 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight text-foreground mb-6">
                        Simple Pricing. <br />
                        <span className="text-muted-foreground">No hidden surprises.</span>
                    </h1>
                    <p className="text-sm sm:text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl mx-auto">
                        Choose a plan that fits your current needs. Upgrade or downgrade anytime.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.2 }}
                >
                    <SaaSShowcase />

                    <div className="mt-32 pt-20 border-t border-border/50">
                        <div className="max-w-3xl mx-auto">
                            <FAQ />
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default PricingPage;
